module.exports = __webpack_public_path__ + "img/default-avatar.7cde1594.png";